export const LV_ADDomainTR={
ADDoID:{en:'ADDoID',cs:'ADDoID',dataType:'number',format:'#0',required:true},
ADDoDomainName:{en:'Domain',cs:'',dataType:'string',required:true,maxLength:100},
ADDoTimeStamp:{en:'ADDoTimeStamp',cs:'ADDoTimeStamp',dataType:'number',format:'#0'}
}